"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ic_expand_less = void 0;
var ic_expand_less = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    }
  }]
};
exports.ic_expand_less = ic_expand_less;